// Light inline formatting for long body text (EParas). The text stays plain in the CMS; these
// markers are turned into elements when the page is shown. Nothing is ever inserted as HTML,
// so there is nothing to sanitise:
//   **bold**   __italic__   [link text](/page)   (links: /page, https://…, mailto: or tel: only)
// Text without markers renders exactly as before.
import { createElement as h } from "react";

const TOKEN = /\*\*(.+?)\*\*|__(.+?)__|\[([^\]\n]+)\]\(([^)\s]+)\)/g;
const SAFE_HREF = /^(\/(?!\/)[^\s]*|https:\/\/[^\s]+|mailto:[^\s]+|tel:[^\s]+)$/;

export function renderInline(text) {
  const out = [];
  let last = 0;
  let m;
  const re = new RegExp(TOKEN.source, "g");
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const key = out.length;
    if (m[1] !== undefined) out.push(h("strong", { key }, m[1]));
    else if (m[2] !== undefined) out.push(h("em", { key }, m[2]));
    else if (SAFE_HREF.test(m[4])) out.push(h("a", { key, href: m[4] }, m[3]));
    else out.push(m[0]); // unsafe or unknown link target: show the text as typed, no link
    last = re.lastIndex;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
